"use client";

import PageNotFound from "@/components/PageNotFound";

export default function NotFound({ props }) {
  const pageProps = { ...props };

  return (
    <div>
      <PageNotFound {...pageProps} />
    </div>
  );
}
